import { useState } from 'react'
import styled from 'styled-components'

import { formatPriceByLocale } from 'utils/utils'

import SVGIcon from 'components/presenters/common/SVGIcon'

export default function PackageServiceInfo({ price, jejuPrice, otherPrice, shippingName }) {
  const [isExpand, setIsExpand] = useState(false)

  const onToggleExpand = () => {
    isExpand === true ? setIsExpand(false) : setIsExpand(true)
  }

  return (
    <>
      <PackageServiceSection>
        <SectionLeft>
          <IconWrapper>
            <SVGIcon name="packageTruck" />
          </IconWrapper>
          <PackageInfoTitle>배송정보</PackageInfoTitle>
        </SectionLeft>
        <PackageInfoValue>{shippingName}</PackageInfoValue>
      </PackageServiceSection>
      <PackagePriceSection onClick={onToggleExpand}>
        <SectionLeft>
          <IconWrapper>
            <SVGIcon name="cash" />
          </IconWrapper>
          <PackageInfoTitle>배송비</PackageInfoTitle>
        </SectionLeft>
        <PackageInfoValue>{price && formatPriceByLocale('ko', price)}원 </PackageInfoValue>
        {isExpand ? (
          <ExpandIconWrapper rotate={270}>
            <SVGIcon name="arrowIcon" />
          </ExpandIconWrapper>
        ) : (
          <ExpandIconWrapper rotate={90}>
            <SVGIcon name="arrowIcon" />
          </ExpandIconWrapper>
        )}
      </PackagePriceSection>
      <PackageExceptionSection isExpand={isExpand}>
        <div>
          {jejuPrice && (
            <PackageExceptionStyle>{`제주 지역 : ${formatPriceByLocale(
              'ko',
              jejuPrice,
            )}원 추가`}</PackageExceptionStyle>
          )}
          {otherPrice && (
            <PackageExceptionStyle>{`제주 외 도서산간지역 : ${formatPriceByLocale(
              'ko',
              otherPrice,
            )}원 추가`}</PackageExceptionStyle>
          )}
        </div>
      </PackageExceptionSection>
    </>
  )
}

const PackageServiceSection = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: calc(100vw * (19 / 375));
`

const PackagePriceSection = styled(PackageServiceSection)`
  margin-bottom: calc(100vw * (3 / 375));
`

const SectionLeft = styled.div`
  display: flex;
  align-items: center;
  width: calc(100vw * (90 / 375));
  min-width: calc(100vw * (90 / 375));
`

const IconWrapper = styled.div`
  height: calc(100vw * (15.76 / 375));
  width: calc(100vw * (21 / 375));
  margin-right: calc(100vw * (5 / 375));

  svg {
    color: #4e4e4e;
  }
`

const PackageInfoTitle = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: 150%;
  color: #4e4e4e;
`

const PackageInfoValue = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: calc(100vw * (14 / 375));
  line-height: 150%;
  color: #121212;
`

const ExpandIconWrapper = styled.div`
  transform: ${({ rotate }) => {
    return rotate ? `rotate(${rotate}deg)` : `rotate(90deg)`
  }};
  margin-left: calc(100vw * (11 / 375));
  width: calc(100vw * (6 / 375));
  height: calc(100vw * (10 / 375));
  display: inline-block;

  svg {
    fill: #828282;
  }
`

const PackageExceptionSection = styled.div`
  display: flex;
  transition: max-height 0.3s ${({ isExpand }) => (isExpand === true ? 'ease-in' : 'ease-out')};
  max-height: ${({ isExpand }) => (isExpand === true ? 'calc(100vw * (120 / 375))' : '0')};
  padding-left: calc(100vw * (90 / 375));
  overflow: hidden;
`

const PackageExceptionStyle = styled.div`
  font-weight: 400;
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (19 / 375));
  color: #989898;
`
